<div class="expense-row" (click)="onRowClick()">
    <div class="info-section">
        <div class="field amount">
            <span class="label" translate>questionBoard.edit.expense.amountInILS</span>
            <span class="value">{{ row.amount | number }} ₪</span>
        </div>
        <div class="field date">
            <span class="label" translate>questionBoard.edit.expense.date</span>
            <span class="value">{{ row.date | queDate }}</span>
        </div>
        <div class="field type">
            <span class="label" translate>questionBoard.edit.expense.expenseType</span>
            <span class="value">{{ row.expenseTypeName }}</span>
        </div>
        <div class="field description">
            <span class="label" translate>questionBoard.edit.expense.description</span>
            <span class="value" [class.empty]="!row.description">{{ row.description || '—' }}</span>
        </div>
        <div class="field files">
            <span class="label" translate>questionBoard.edit.expense.attachmentFiles</span>
            <div class="files-list" *ngIf="row.files?.length; else noFiles">
                <a class="file-link" *ngFor="let file of row.files" (click)="openFile(file, $event)">{{ file.fileName }}</a>
            </div>
            <ng-template #noFiles><span class="value empty">—</span></ng-template>
        </div>
    </div>

    <div class="approval-section">
        <div class="field toggle-field" (click)="$event.stopPropagation()">
            <span class="label" translate>questionBoard.edit.expense.clientCharge</span>
            <que-toggle [toggleState]="!!row.clientCharge" (toggleEvent)="toggleClientCharge($event)"></que-toggle>
        </div>

        <div class="field toggle-buttons" (click)="$event.stopPropagation()">
            <span class="label" translate>questionBoard.edit.expense.fullcharge</span>
            <div class="segmented" *ngIf="row.clientCharge; else noSegmented">
                <button type="button" [class.active]="row.fullcharge === true" [disabled]="!canEdit"
                    (click)="setFullcharge(true, $event)" translate>questionBoard.edit.expense.chargeFull</button>
                <button type="button" [class.active]="row.fullcharge === false" [disabled]="!canEdit"
                    (click)="setFullcharge(false, $event)" translate>questionBoard.edit.expense.chargePartial</button>
            </div>
            <ng-template #noSegmented><span class="value empty">—</span></ng-template>
        </div>
        <div class="field" (click)="$event.stopPropagation()">
            <span class="label" translate>questionBoard.edit.expense.clientChargeAmount</span>
            <input *ngIf="row.clientCharge; else noChargeAmount" type="number" step="0.01" min="0" [value]="row.clientChargeAmount" [disabled]="!canEdit" (blur)="saveClientChargeAmount($event)" />
            <ng-template #noChargeAmount><span class="value empty">—</span></ng-template>
        </div>

        <div class="field" (click)="$event.stopPropagation()">
            <span class="label" translate>questionBoard.edit.expense.approvedAmount</span>
            <input type="number" step="0.01" min="0" [max]="row.amount" [value]="displayApprovedAmount"
                [disabled]="!canEdit" [class.has-error]="approvedAmountError" (blur)="saveApprovedAmount($event)" />
            <span class="error-message" *ngIf="approvedAmountError" translate>questionBoard.edit.expense.approvedAmountGreaterThanAmount</span>
        </div>
        <div class="field comment" (click)="$event.stopPropagation()">
            <span class="label" translate>questionBoard.edit.expense.commentAproval</span>
            <input type="text" [value]="row.commentAproval" [disabled]="!canEdit" (blur)="saveComment($event)" />
        </div>
    </div>
</div>
